{
    "button__in_1_week": "Dans 1 semaine",
    "button__in_4_week": "Dans 4 semaines"
}
